import { motion } from "framer-motion";

const IMG =
  "https://images.unsplash.com/photo-1629904853893-c2c8981a1dc5?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1400";

const VALUES = [
  {
    k: "Trust",
    v: "Long-lasting partnerships anchored in transparency and mutual success.",
  },
  {
    k: "Rigor",
    v: "Investment in team development and standardised technical vetting frameworks.",
  },
  {
    k: "Outcomes",
    v: "Quality-of-hire and business impact — not time-to-fill vanity metrics.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      className="relative py-28 sm:py-36 border-t border-slate-200"
      data-testid="about-section"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-10 items-start">
          <div className="col-span-12 lg:col-span-6 relative">
            <motion.div
              initial={{ opacity: 0, scale: 0.98, y: 24 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.9, ease: [0.21, 0.47, 0.32, 0.98] }}
              className="relative rounded-3xl overflow-hidden border border-slate-200 shadow-[0_18px_44px_rgba(15,23,42,0.08)]"
            >
              <div className="absolute inset-0 bg-gradient-to-t from-white/50 via-transparent to-transparent z-10 pointer-events-none" />
              <img
                src={IMG}
                alt="Enterprise engineering team collaborating on delivery dashboards"
                className="h-[520px] w-full object-cover"
                loading="lazy"
              />
              <div className="absolute top-6 left-6 z-20 rounded-full border border-teal-500/40 bg-white/85 backdrop-blur-md px-4 py-2 font-mono-a text-[10px] uppercase tracking-[0.28em] text-teal-700">
                Delivery Hubs · Pune · Vadodara
              </div>
            </motion.div>
          </div>

          <div className="col-span-12 lg:col-span-6">
            <div className="mb-3 font-mono-a text-[11px] uppercase tracking-[0.28em] text-teal-700">
              / 008 · About Visionary
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight leading-[1.05]">
              Driven by a passion
              <br />
              <span className="font-serif-a italic font-normal text-slate-500">
                for excellence.
              </span>
            </h2>
            <p className="mt-6 text-slate-700 text-base sm:text-lg leading-relaxed max-w-[52ch]">
              Visionary Staffing Solutions builds India-focused talent
              ecosystems that drive sustainable growth. By combining strategic
              workforce consulting, diversity-focused recruitment, and industry
              expertise, we deliver next-generation talent acquisition
              solutions that help organisations scale and succeed.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed max-w-[52ch]">
              Our mission is to empower clients to achieve their goals through
              customised solutions that meet their unique needs. We invest in
              our people so they deliver the highest quality services to
              yours.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {VALUES.map((v) => (
                <div
                  key={v.k}
                  className="rounded-2xl border border-slate-200 bg-white p-5"
                >
                  <div className="font-display text-lg text-slate-900 font-bold">
                    {v.k}
                  </div>
                  <div className="mt-2 text-slate-600 text-sm leading-relaxed">
                    {v.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
